module.exports = __webpack_public_path__ + "static/media/josue_mejia_12.0e1c4a29.jpg";